/**
 * Two-factor code prompt during sign-in - replaces allauth's mfa/authenticate.html
 * Shown after a correct password for a user with an authenticator app.
 */
import { Button } from "@mui/material";
import { AuthLayout, BRAND_COLORS } from "../components/AuthLayout";
import {
  CodeField,
  MFA_URLS,
  MfaContent,
  MfaMessages,
  MfaText,
  PostForm,
  PrimaryButton,
} from "../components/MfaParts";
import { useFieldErrors } from "../hooks/useAuthContext";
import { gettext } from "@services/i18n";

const TITLE = gettext("Two-factor authentication");
const INTRO = gettext(
  "Your account is protected by two-factor authentication. Enter the code from your authenticator app.",
);
const RECOVERY_CODE_HINT = gettext(
  "Lost your phone? Enter one of your recovery codes instead.",
);
const SIGN_IN = gettext("Sign In");
const CANCEL = gettext("Cancel");

export function MfaAuthenticatePage() {
  const codeErrors = useFieldErrors("code");

  return (
    <AuthLayout title={TITLE}>
      <MfaContent>
        <MfaMessages />
        <MfaText>{INTRO}</MfaText>
        <PostForm action={MFA_URLS.authenticate}>
          <CodeField errors={codeErrors} helperText={RECOVERY_CODE_HINT} />
          <PrimaryButton type="submit" data-testid="mfa-authenticate-submit">
            {SIGN_IN}
          </PrimaryButton>
        </PostForm>
        {/* Cancel ends the half-finished login, as allauth's own template does */}
        <PostForm action={MFA_URLS.logout}>
          <input type="hidden" name="next" value={MFA_URLS.login} />
          <Button
            type="submit"
            fullWidth
            sx={(theme) => ({
              marginTop: theme.spacing(1.5),
              color: BRAND_COLORS.link,
              textTransform: "none",
              fontWeight: 500,
              "&:hover": {
                color: BRAND_COLORS.linkHover,
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            })}
            data-testid="mfa-authenticate-cancel"
          >
            {CANCEL}
          </Button>
        </PostForm>
      </MfaContent>
    </AuthLayout>
  );
}
